import { useEffect, useState } from 'react'

export const useSlideNavigation = () => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)
  const [currentConversationIndex, setCurrentConversationIndex] = useState(0)

  const resetConversationIndex = () => setCurrentConversationIndex(0)

  useEffect(() => {
    resetConversationIndex()
  }, [currentSlideIndex])

  return {
    currentSlideIndex,
    currentConversationIndex,
    setCurrentSlideIndex,
    setCurrentConversationIndex,
    resetConversationIndex,
  }
}
